import { EditableDashboard, EditableDashboardElement } from '@sdbn/common';
import { HttpHeaders } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AppServerAPI } from '@sdbn/common';
import { AbstractWidgetComponent } from '@sdbn/common';
import { ContextChange } from '@sdbn/common';

@Component({
  selector: 'app-image-view-editor',
  templateUrl: './image-view-editor.component.html',
  styleUrls: ['./image-view-editor.component.scss']
})
export class ImageViewEditorComponent extends AbstractWidgetComponent implements OnInit {

  requestRunning = false;

  filename = '';

  private dashboard: EditableDashboard = null;
  private dashboardElement: EditableDashboardElement = null;

  @ViewChild('pictureBtn') imageElement: ElementRef;

  constructor(
    private appServerAPI: AppServerAPI
  ) {
    super();
  }

  public setWidgetConfigurationAndDashboard(dashboard: EditableDashboard, dashboardElement: EditableDashboardElement) {
    this.dashboard = dashboard;
    this.dashboardElement = dashboardElement;
    this.filename = dashboardElement.data.filename;
  }

  ngOnInit(): void {
  }

  onContextChange(contextChange: ContextChange) {
  }
  onSetElementAndContext() {
  }

  chooseAndUpload() {
    this.imageElement.nativeElement.click();
  }

  handlePictureEvent(event: Event) {
    this.requestRunning = true;
    const files = (event.target as HTMLInputElement).files;
    if (files != null) {
      for (let i = 0; i < files.length; i++) {
        const current: File = files.item(i);
        const name = current.name;
        const type = current.type;
        const reader = new FileReader();
        // Callback handler must be registered before calling readAsArrayBuffer
        reader.onload = () => {
          this.uploadImage(type, name, reader.result);
        };
        reader.readAsArrayBuffer(current);

      }
    }
  }

  private uploadImage(type: string, name: string, content: any): Promise<void> {
    return this.appServerAPI.postFile('/client/resource/upload', content, new HttpHeaders({
      'Content-Type': type,
      'Content-MD5': 'test', // TODO: Calculate MD5 hash of capture.blob
      context: '' + this.dashboard.id,
      filename: encodeURIComponent(name)
    })).toPromise().then(response => {
      this.requestRunning = false;
      this.filename = name;
      this.addImageToDocument(name, response['resourceUUID']);
    }, error => {
      console.log('saveDocument call failed:', error);
      this.requestRunning = false;
    });
  }

  private addImageToDocument(filename: string, resourceUUID: string) {
    if (this.dashboardElement.data == null) {
      this.dashboardElement.data = {};
    }
    this.dashboardElement.data.filename = filename;
    this.dashboardElement.data.resourceUUID = resourceUUID;
    this.dashboard.setDirty();
  }
}
